import {
    type ChangePasswordResponseType,
    type ChangePasswordRequestType
} from "./types";
import axios from "axios";
import {
    SERVER_ADDRESS
} from "../../constants";
import {
    getHeaders
} from "../../utils";

const ChangePassword = async (params: ChangePasswordRequestType): Promise<ChangePasswordResponseType> => {
    return await axios(`${SERVER_ADDRESS}/profile/changePassword`, {
        method: "PUT",
        headers: getHeaders(true),
        data: params
    })
        .then((res) => {
            if (
                res.status === 200 ||
                res.status === 201 ||
                res.status === 202
            ) {
                return res.data;
            }

            throw res;
        })
        .catch((err) => {
            if (err && err.response && err.response.data) {
                throw err.response.data;
            }

            throw err;
        });
};
export default ChangePassword;
